module.exports = __webpack_public_path__ + "static/01-what-is-happy-b459fedd95d71d1262603dcdda522374.png";